<div class="page-title">
  <div class="title">
    {{title}}
  </div>
</div>
